import {
  LIST_PARTNERS,
  CREATE_PARTNER,
  UPDATE_PARTNER,
} from '@/data/actions/modules/referral';

export default [
  {
    path: '/partners',
    component: () => import(/* webpackChunkName: "partners" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: LIST_PARTNERS,
    },
  },
  {
    path: '/partners/create',
    component: () => import(/* webpackChunkName: "partners" */ './components/Form.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: CREATE_PARTNER,
    },
  },
  {
    path: '/partners/:id/edit',
    component: () => import(/* webpackChunkName: "partners" */ './components/Form.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: UPDATE_PARTNER,
    },
  },
];
